// extracted by mini-css-extract-plugin
export var container = "NarrativeSection-module--container--83a5b";
export var footer = "NarrativeSection-module--footer--29be9";
export var gatsbyImageWrapper = "NarrativeSection-module--gatsby-image-wrapper--b18aa";
export var imgCol = "NarrativeSection-module--imgCol--4e8f2";
export var row = "NarrativeSection-module--row--3d9c6";
export var rowFlip = "NarrativeSection-module--rowFlip--9b259";
export var section = "NarrativeSection-module--section--5389c";
export var sectionHeading = "NarrativeSection-module--sectionHeading--9cd92";
export var tag = "NarrativeSection-module--tag--2e8c4";
export var text = "NarrativeSection-module--text--c96a8";
export var textCol = "NarrativeSection-module--textCol--12614";
export var title = "NarrativeSection-module--title--ca961";